import React, { useState } from 'react';
import { toast } from 'sonner'; // Import Sonner for toast notifications

// Define the type for a shortcode
type Shortcode = {
  shortcode: string;
  description: string;
};

const TimeTableShortCodeDocs: React.FC = () => {
  // List of shortcodes and their descriptions
  const shortcodes: Shortcode[] = [
    {
      shortcode: '[Fp_TimeTable_Monthly]',
      description: 'Displays the monthly timetable for prayer times with a printer button inside the table.',
    },
    {
      shortcode: '[Fp_Vertical_Daily_Prayer]',
      description: 'Displays the vertical daily prayer timetable.',
    },
    {
      shortcode: '[Fp_TimeTable_Monthly printer_option="outside"]',
      description: 'Displays the monthly timetable for prayer times with a printer button outside the table.',
    },
  ];

  // State to track copied shortcodes
  const [copiedShortcodes, setCopiedShortcodes] = useState<{ [key: string]: boolean }>({});

  // Function to copy shortcode to clipboard with HTTP check
  const copyToClipboard = (shortcode: string) => {
    if (window.location.protocol !== 'https:') {
      toast.warning(
        "Copy function doesn't work on HTTP. Please switch to HTTPS or use right-click to copy manually."
      );
      return;
    }

    navigator.clipboard
      .writeText(shortcode)
      .then(() => {
        setCopiedShortcodes((prev) => ({ ...prev, [shortcode]: true }));

        toast.success('Shortcode copied to clipboard!');

        setTimeout(() => {
          setCopiedShortcodes((prev) => ({ ...prev, [shortcode]: false }));
        }, 2000);
      })
      .catch((err) => {
        console.error('Failed to copy:', err);
        toast.error('Failed to copy shortcode.');
      });
  };

  return (
    <div className="font-sans p-5">
      <h1 className="text-2xl font-bold mb-4">FivePrayer Shortcodes Documentation</h1>
      <p className="mb-6 text-gray-700">
        Below is a list of all available shortcodes for displaying prayer times and other related information. Click the "Copy" button to copy the shortcode to your clipboard.
      </p>

      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-3 border border-gray-300">Shortcode</th>
            <th className="p-3 border border-gray-300">Description</th>
            <th className="p-3 border border-gray-300">Action</th>
          </tr>
        </thead>
        <tbody>
          {shortcodes.map((item, index) => (
            <tr key={index} className="border-b border-gray-300">
              <td className="p-3 border border-gray-300">
                <code className="bg-gray-100 p-1 rounded">{item.shortcode}</code>
              </td>
              <td className="p-3 border border-gray-300">{item.description}</td>
              <td className="p-3 border border-gray-300">
                <button
                  onClick={() => copyToClipboard(item.shortcode)}
                  className={`px-4 py-2 rounded w-24 ${
                    copiedShortcodes[item.shortcode]
                      ? 'bg-green-500 text-white'
                      : 'bg-blue-500 text-white hover:bg-blue-600'
                  } transition-colors`}
                >
                  {copiedShortcodes[item.shortcode] ? 'Copied!' : 'Copy'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TimeTableShortCodeDocs;
